import {FormTracker} from "@/form-tracker";

export class DynamicsFormHandler {

    constructor(selector: string) {

        document.querySelectorAll<HTMLFormElement>(selector).forEach((target) => {
            const observer = new MutationObserver((mutationsList, observer) => {
                if (target.querySelector("form")) {
                    console.log("Form is initialised");
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const tracker = new FormTracker([".marketingForm"]);
                    observer.disconnect();
                }
            });
            observer.observe(target, { childList: true, subtree: true });
        })
    }

}
